import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment-timezone';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { INoticeBoardPosts, IPostComments } from 'src/app/models/notice-board';
import { UserRegDetails } from 'src/app/models/user';
import { IUserPolls } from 'src/app/models/user-polls';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-status-comments',
  templateUrl: './status-comments.component.html',
  styleUrl: './status-comments.component.scss',
})
export class StatusCommentsComponent {
  @Input() set incident(val: IIncidents) {
    if (val) {
      this.incidentDetails = val;
      if (this.isSet) {
        this.setUserPostdata();
      }
    }
  }
  @Input() set orgUsers(val: UserRegDetails[]) {
    if (val) {
      this.isSet = true;
      this.orgUserDetails = val;
      if (this.incidentDetails) {
        this.setUserPostdata();
      }
    }
  }
  isSet = false;
  selectedCommentIdZoom: string = null;
  @Input() set selectedCommentId(val: string) {
    if (val) {
      setTimeout(() => {
        this.onScrollToComment(val);
      }, 500);
    }
  }
  @Input() screenInfo: ScreenType = ScreenType.Desktop;
  @ViewChild('OnZoomDialog', { static: true }) onZoomDialog: TemplateRef<any>;
  @ViewChild('commentTextarea') commentTextarea: ElementRef;
  @Output() onPostComment = new EventEmitter();
  @Output() onPostLike = new EventEmitter();
  @Output() onPostShare = new EventEmitter();
  @Output() openSharedPostPoll = new EventEmitter();
  @ViewChild('commentTextarea')
  commentTextareaRef!: ElementRef<HTMLTextAreaElement>;
  incidentDetails: IIncidents;
  orgUserDetails: UserRegDetails[];
  poll: IUserPolls;
  commentControl = new FormControl();
  uploadedAttachmentControl = new FormControl();
  uploadedAttachment = '';
  loggedIsUsername = '';
  loggedIsUsernameProfile = '';
  userId = '';
  isChangedLike = false;
  decryptedUserData: any;
  userImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAMFBMVEXk5ueutLepr7Ln6erg4uPJzc/T1ti7wMO2u77DyMqzuLvq7O3P0tTW2dvc3+DZ3N7ueM45AAAC2UlEQVR4nO2a2ZLjIAxFAYHZvPz/3za2O8v0JCA5kl3dxXly5eXeCAmDZKU6nU6n0+l0Op1O5/cCAErZglofzle3UwxJryTvFnWuB4DJa2P0DWNSnM+zAHnUD/G7Cb/kc/Tz9EJ+t3DKQkB8Lb8xiDsAFSr62jhhB2BTRX51EEUdgK3Lb4kg6qDx/6VjAL6tXxyMUg7A1fLvyYHQngQLTr/szUIGAlJfqBhhxAagIKCvAC+vtUQIBkIAtOE3kNEZsBkQKEVKALQO3AZIKbiGwHIbQG2CTwbYX8w0fa253wgzbQVKEvDqA6kIN5gNIN9DT8y8BiJVXy8XGzATrwFiFa51+McMXL4Elyfh1WVIOw1s8OorS96K/9rL6PLXMfVAorkPJApoBvivqLQ1MBP/oRR9MdsQuBcA4mp+D4DI3WwihEDkdorPAv4j8U67P/ONVJcGvRdYqRZJ9hgHEiV4A9OjkGsRbVTblJu+dKuy4UBcvxRjtVUr3ywup7P38uGUoQHM74Lgzprd5OVFJpgoVv6vLMzu35FNGE+eGq1TqzH6kFIKPg7XDM4y3Mhnz8zK/7XLMLq44cZhmfdfTxDPah5jKKu+ck+B9TlFNynRYKzDSheek+9nIWiT4mBlIlGCPnj9ZmD3bMLo4Gb2kthHpS3xhwk/sFoA5RLxXmLKvsQ1SAVbG1VWPISFIwpF/oj6bsEzWHg1pyZYiJ/lQl6oa/+fAz1+kAr52OL/sJCOBgHm5gEQybFjEgw86nrLBDqZ3herOPDkRKh+pnDAAXV8wKyvqQMMfn2aA9b1fzhA5wFQWhF48N9WkLuiWAfY/YA0pCWBamAfaIyjQTWQ0Y2YA2B6B5k8nCHRDgB5REqi3T6gT6eINNdANADtUpQsgR3fCIDcHnCjPkiQ2gQf1NfgwJSeTPVscmA+SSbVVgD/tdYHVJOAMJQ4TG2ma78bD6LwjtU7nU6n8/v5AuY6HZyRatEhAAAAAElFTkSuQmCC';

  constructor(
    private dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {
    this.loggedIsUsernameProfile = localStorage.getItem('ProfilePic')
      ? localStorage.getItem('ProfilePic')
      : this.userImage;
    this.decryptedUserData = this.encryptionService.decrypt(
      localStorage.getItem('UserDetails')
    );
    this.userId = this.decryptedUserData.UserID;
  }
  isShowDetails = false;
  post: INoticeBoardPosts;
  setUserPostdata() {
    this.selectedAttachment = null;
    if (this.incidentDetails.incidentType.toLowerCase() == 'automatic') {
      let userDetails = this.userImage;
      const newCOmment = this.parseAllComments(
        this.incidentDetails.incidentComments
      );
      this.post = {
        postId: this.incidentDetails.incidentId,
        postDescription: this.incidentDetails.incidentDescription,
        postAttachment: null,
        postUsername: 'Automatic',
        postUserProfile: userDetails,
        postShared: false,
        postSharedId: null,
        postUserId: this.incidentDetails.eventCreatedByUserID,
        postAddDate: new Date(this.incidentDetails.eventCreateDate),
        postValidDate: new Date(this.incidentDetails.eventCreateDate),
        postComments: newCOmment,
        postLikes: [],
        isIncident: true,
      };
    } else {
      let userDetails = this.orgUserDetails.find(
        (x) =>
          x.userId.toLowerCase() ===
          this.incidentDetails.eventCreatedByUserID.toLowerCase()
      )?.profilePicture;
      if (!userDetails) {
        userDetails = this.userImage;
      }
      const newCOmment = this.parseAllComments(
        this.incidentDetails.incidentComments
      );
      this.post = {
        postId: this.incidentDetails.incidentId,
        postDescription: this.incidentDetails.incidentDescription,
        postAttachment: null,
        postUsername: this.incidentDetails.eventCreatedBy,
        postUserProfile: userDetails,
        postShared: false,
        postSharedId: null,
        postUserId: this.incidentDetails.eventCreatedByUserID,
        postAddDate: new Date(this.incidentDetails.eventCreateDate),
        postValidDate: new Date(this.incidentDetails.eventCreateDate),
        postComments: newCOmment,
        postLikes: [],
        isIncident: true,
      };
    }
    this.isShowDetails = true;
  }

  focusTextarea() {
    this.commentTextarea.nativeElement.focus();
  }
  onCommentInput() {
    const commentPost = {
      isIncident: true,
      comment: this.commentControl.value,
      post: JSON.stringify(this.post),
      userProfile: localStorage.getItem('ProfilePic')
        ? localStorage.getItem('ProfilePic')
        : this.userImage,
      username:
        this.decryptedUserData.FirstName +
        ' ' +
        this.decryptedUserData.LastName,
      commentMentioned: this.postMentionedUsers,
      attachment: this.selectedAttachment,
    };

    const newComment = {
      isAuto: 'false',
      postId: this.post.postId,
      commentId: this.post.postUserId,
      commentText: this.commentControl.value,
      commentUsername: commentPost.username,
      commentUserId: this.decryptedUserData.UserID,
      commentUserProfile: commentPost.userProfile,
      commentAddDate: new Date(),
      isIncident: 'true',
      isVisitor: 'false',
    };
    const newPostComments = [newComment, ...this.post.postComments];
    this.post.postComments = newPostComments;
    this.onPostComment.emit(commentPost);
    this.commentControl.reset();
    this.postMentionedUsers = [];
    this.selectedAttachment = null;
  }
  getFormattedDateTime(val: any) {
    const inputTimezone = 'UTC';
    // const date = moment(val, moment.ISO_8601);
    const date = moment.tz(val, moment.ISO_8601, inputTimezone);
    const currentTimezone = moment.tz.guess();
    date.tz(currentTimezone);
    const timeDifference = date.fromNow();
    return timeDifference;
  }
  getDateTimeCurrentTimezone(val: any) {
    const inputTimezone = 'UTC';
    // const date = moment(val, moment.ISO_8601);
    const date = moment.tz(val, moment.ISO_8601, inputTimezone);
    const currentTimezone = moment.tz.guess();
    const localDate = date.tz(currentTimezone);
    return localDate.format('DD-MM-YYYY HH:mm:ss');
  }
  filteredUserOrgList: UserRegDetails[] = [];
  postMentionedUsers: UserRegDetails[] = [];
  showUserList = false;
  selectedMention: string | null = null;
  selectedIndex: number = -1;
  onCommentInputCheck() {
    const textarea = this.commentTextareaRef.nativeElement;
    const caretPos = textarea.selectionStart;
    const text = textarea.value;

    const textBeforeCaret = text.substring(0, caretPos);
    const atIndex = textBeforeCaret.lastIndexOf('@');

    if (
      atIndex !== -1 &&
      (atIndex === 0 || /\s/.test(textBeforeCaret[atIndex - 1]))
    ) {
      const term = textBeforeCaret.substring(atIndex + 1);
      if (term.length >= 0) {
        this.filteredUserOrgList = this.orgUserDetails.filter(
          (user) =>
            user.firstname.toLowerCase().includes(term.toLowerCase()) ||
            user.lastname.toLowerCase().includes(term.toLowerCase())
        );
        this.showUserList = this.filteredUserOrgList.length > 0;
      } else {
        this.showUserList = false;
      }
    } else {
      this.showUserList = false;
    }
  }

  // onCommentInputCheck(event: Event) {
  //   const inputText = this.commentControl.value;
  //   const atIndex = inputText.lastIndexOf('@');
  //   if (atIndex !== -1) {
  //     const searchTerm = inputText.substring(atIndex + 1);
  //     this.filteredUserOrgList = this.orgUserDetails.filter(
  //       (user) =>
  //         user.firstname.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //         user.lastname.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //     this.showUserList = this.filteredUserOrgList.length > 0;
  //   } else {
  //     this.showUserList = false;
  //   }
  // }
  selectUser(user: UserRegDetails) {
    const textarea = this.commentTextareaRef.nativeElement;
    const inputText = this.commentControl.value;
    const caretPos = textarea.selectionStart;

    const textBeforeCaret = inputText.substring(0, caretPos);
    const textAfterCaret = inputText.substring(caretPos);

    // Find last '@' before caret
    const atIndex = textBeforeCaret.lastIndexOf('@');

    // Build updated text
    const tagText = '@' + user.firstname + ' ' + user.lastname;
    const newText =
      textBeforeCaret.substring(0, atIndex) +
      tagText +
      ' ' + // Add space after tag
      textAfterCaret;

    // Update form control and push to mentioned users list
    this.commentControl.setValue(newText);
    this.postMentionedUsers.push(user);
    this.showUserList = false;

    // Move caret to right after inserted tag
    setTimeout(() => {
      textarea.focus();
      const newCaretPos = atIndex + tagText.length + 1;
      textarea.setSelectionRange(newCaretPos, newCaretPos);
    });
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.selectedIndex < this.filteredUserOrgList.length - 1) {
        this.selectedIndex++;
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
      }
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (this.selectedIndex !== -1) {
        const selectedUser = this.filteredUserOrgList[this.selectedIndex];
        // this.selectUser(selectedUser);
      }
      if (!!this.commentControl.value) {
        this.onCommentInput();
      }
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.showUserList = false;
    }
  }
  parseAllComments(val: IPostComments[]): any[] {
    let newComments = val.map((x) => {
      // Create a new object and copy existing properties
      let newComment = { ...x };
      if (x.incidentEvidence && x.incidentEvidence.length > 10) {
        newComment.isMultiple = true;
        newComment.parsedImages = JSON.parse(x.incidentEvidence);
      } else {
        newComment.isMultiple = false;
        newComment.parsedImages = null;
      }

      return newComment; // Ensure the modified object is returned
    });
    return newComments;
  }
  isDoc = false;
  isPdf = false;
  isImage = true;
  isNewEvidence = false;
  pdfLoaded = false;
  evidence = '';
  onPdfLoad() {
    this.pdfLoaded = true;
  }
  onDataLoaded(data: any) {
    // this.excelData = data;
    console.log('dataAddedExcel');
  }
  onShowEvidence(val: any) {
    this.isPdf = false;
    this.isImage = false;
    this.isDoc = false;
    if (val.FileType.includes('image')) {
      this.evidence = val.Url;
      this.isImage = true;
    } else if (val.FileType.includes('pdf')) {
      this.evidence = val.Url;
      this.isPdf = true;
    } else if (
      val.FileType.includes(
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      )
    ) {
      this.evidence = val.Url;
      this.isDoc = true;
    } else {
      this.evidence = val.Url;
    }
    this.onClicktoZoom();
  }
  onClicktoZoom() {
    this.dialog.open(this.onZoomDialog, {
      height: '600px',
      width: '960px',
    });
  }
  isScrollError = false;
  onScrollToComment(commentId: string) {
    const commentIndex = this.post.postComments.findIndex(
      (comment) => comment.commentId === commentId
    );
    if (commentIndex !== -1) {
      const commentElements = document.querySelectorAll(
        '.user-comment-wrapper'
      );
      const targetElement = commentElements[commentIndex];
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start', // Adjusts the position to the top of the viewport
      });
      this.selectedCommentIdZoom = commentId;
      setTimeout(() => {
        // this.selectedCommentIdZoom = null;
      }, 1500);
    } else {
      this.isScrollError = true;
    }
  }
  extractDate(input: string): Date | null {
    // Define the regex pattern to match the date and time
    const datePattern = /\b\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}\b/;

    // Match the date and time in the string
    const match = input.match(datePattern);

    if (match) {
      const dateString = match[0]; // Extract the matched date string
      // Convert the date string to a Date object (adjust format if needed)
      const dateParts = dateString.split(' '); // Separate date and time
      const [day, month, year] = dateParts[0].split('-').map(Number);
      const [hours, minutes, seconds] = dateParts[1].split(':').map(Number);
      const extractedDate = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds
      );

      console.log('Extracted Date:', extractedDate);
      return extractedDate;
    } else {
      console.error('No date found in the input string.');
      return null;
    }
  }
  selectedMultipleAttachment: any[] = [];
  selectedAttachment: any;
  onAttachmentSelected(event: any): void {
    this.isNewEvidence = true;
    const files: FileList = event.target.files;
    const attachedContents: string[] = []; // Array to store file contents (optional)
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      let contents;

      reader.onload = (e) => {
        contents = e.target.result as string;
        attachedContents.push(contents); // Add content to the array (optional)
        this.selectedMultipleAttachment.push({
          selectedAttachment: file,
          attachedContent: contents,
          attachedContentName: file.name,
          attachedContentType: file.type,
        });
        this.selectedAttachment = {
          selectedAttachment: file,
          attachedContent: contents,
          attachedContentName: file.name,
          attachedContentType: file.type,
        };
      };
      reader.readAsDataURL(file);
      this.selectedAttachment = {
        selectedAttachment: file,
        attachedContent: contents,
        attachedContentName: file.name,
        attachedContentType: file.type,
      };
    }
  }

  ScreenType = ScreenType;
}
